import React, { useState } from 'react';
import Image from 'next/image';
import { Skeleton } from 'antd';

const imgSrcConst ="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
const ImageWithSkeleton = ({ src, alt, width, height, idx = 1, isButton = false, className = '' }: 
  { className?: string, idx?: number, src: string, alt: string, width: number, height: number, isButton?: boolean }) => {
  const [isLoading, setIsLoading] = useState(false); // 控制骨架屏显示
  const [imgSrc, setImgSrc] = useState(imgSrcConst); // 控制错误提示显示

  return (
    <div style={{position: "absolute", top: 0, left: 0, width: '100%', height: '100%', }}>
      {
        isLoading && (
          isButton ?
            <Skeleton.Button
              active
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                
              }}
            />
            :
            <Skeleton.Image
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                
              }}
              active
            />
        )
      }
      <Image
        src={imgSrc}
        data-src={src}
        alt={alt}
        width={width}
        height={height}
        sizes="100vw"
        priority={false}
        className={`w-full h-full ${className} bravve_lic ant-skeleton-image-self`}
        // onLoad={() => setIsLoading(false)} // 图片加载完成后隐藏骨架屏
        // onError={() => {
        //   setIsLoading(false); // 隐藏骨架屏
        // }}
        style={{
          objectFit: 'cover',
          // opacity: isLoading ? 0 : 1, // 图片加载完成后显示
          // transition: 'opacity 0.3s ease-in-out',
        }}
      />
    </div>
  );
};

export default ImageWithSkeleton;